import { Injectable } from "@angular/core";
import { CommonDialogService } from "../../shared/services/common-dialog.service";
import {
  BrandCampaignAdDialogData,
  BrandCampaignAdDialogResult,
  BrandCampaignAdDialogComponent,
} from "./brand-campaign-ad-dialog/brand-campaign-ad-dialog.component";
import {
  CampaignContentPostCommentsDialogComponent,
  CampaignContentPostCommentsDialogData,
  CampaignContentPostCommentsDialogResult,
} from "./brand-campaign-content/campaign-content-post/campaign-content-post-comments-dialog/campaign-content-post-comments-dialog.component";
import {
  BrandCampaignCategoryMoveDialogComponent,
  BrandCampaignCategoryMoveDialogData,
  BrandCampaignCategoryMoveDialogResult,
} from "./brand-campaign-content/brand-campaign-move-post-category-dialog/brand-campaign-move-post-category-dialog.component";
import {
  CampaignAddContentDialogComponent,
  CampaignAddContentDialogData,
  CampaignAddContentDialogResult,
} from "./brand-campaign-content/campaign-add-content-dialog/campaign-add-content-dialog.component";
import {
  CampaignCategoryFormDialogComponent,
  CampaignCategoryFormDialogData,
  CampaignCategoryFormDialogResult,
} from "./brand-campaign-content/campaign-category-form-dialog/campaign-category-form-dialog.component";
import {
  CampaignContentFormBannerDialogComponent,
  CampaignContentFormBannerDialogData,
  CampaignContentFormBannerDialogResult,
} from "./brand-campaign-content/campaign-content-form-banner-dialog/campaign-content-form-banner-dialog.component";
import {
  CampaignContentFormGoogleAdDialogComponent,
  CampaignContentFormGoogleAdDialogData,
  CampaignContentFormGoogleAdDialogResult,
} from "./brand-campaign-content/campaign-content-form-google-ad-dialog/campaign-content-form-google-ad-dialog.component";
import {
  CampaignContentFormLinkPostDialogComponent,
  CampaignContentFormLinkPostDialogData,
  CampaignContentFormLinkPostDialogResult,
} from "./brand-campaign-content/campaign-content-form-link-post-dialog/campaign-content-form-link-post-dialog.component";
import {
  CampaignContentFormPostCarouselDialogComponent,
  CampaignContentFormPostCarouselDialogData,
  CampaignContentFormPostCarouselDialogResult,
} from "./brand-campaign-content/campaign-content-form-post-carousel-dialog/campaign-content-form-post-carousel-dialog.component";
import {
  CampaignContentFormPostImageDialogComponent,
  CampaignContentFormPostImageDialogData,
  CampaignContentFormPostImageDialogResult,
} from "./brand-campaign-content/campaign-content-form-post-image-dialog/campaign-content-form-post-image-dialog.component";
import {
  CampaignContentFormPostVideoDialogComponent,
  CampaignContentFormPostVideoDialogData,
  CampaignContentFormPostVideoDialogResult,
} from "./brand-campaign-content/campaign-content-form-post-video-dialog/campaign-content-form-post-video-dialog.component";
import {
  CampaignContentFormVideoDialogComponent,
  CampaignContentFormVideoDialogData,
  CampaignContentFormVideoDialogResult,
} from "./brand-campaign-content/campaign-content-form-video-dialog/campaign-content-form-video-dialog.component";
import {
  BrandCampaignCreationDialogComponent,
  BrandCampaignCreationDialogData,
  BrandCampaignCreationDialogResult,
} from "./brand-campaign-creation-dialog/brand-campaign-creation-dialog.component";
import {
  BrandCampaignDetailsPreviewDialogComponent,
  BrandCampaignDetailsPreviewDialogData,
  BrandCampaignDetailsPreviewDialogResult,
} from "./brand-campaign-information/brand-campaign-information-details/brand-campaign-details-preview-dialog/brand-campaign-details-preview-dialog.component";
import {
  BrandCampaignBoxPreviewDialogData,
  BrandCampaignBoxPreviewDialogResult,
  BrandCampaignBoxPreviewDialogComponent,
} from "./brand-campaign-information/brand-campaign-information-settings/brand-campaign-box-preview-dialog/brand-campaign-box-preview-dialog.component";
import {
  CampaignPartnersInviteConfirmDialogComponent,
  CampaignPartnersInviteConfirmDialogData,
  CampaignPartnersInviteConfirmDialogResult,
} from "./brand-campaign-invite-partners/campaign-partners-invite-confirm-dialog/campaign-partners-invite-confirm-dialog.component";
import {
  BrandCampaignMoveDialogComponent,
  BrandCampaignMoveDialogData,
  BrandCampaignMoveDialogResult,
} from "./brand-campaign-move-dialog/brand-campaign-move-dialog.component";
import {
  BrandCampaignNameEditDialogComponent,
  BrandCampaignNameEditDialogData,
  BrandCampaignNameEditDialogResult,
} from "./brand-campaign-name-edit-dialog/brand-campaign-name-edit-dialog.component";
import {
  BrandCampaignPartnerEditDialogComponent,
  BrandCampaignPartnerEditDialogData,
  BrandCampaignPartnerEditDialogResult,
} from "./brand-campaign-partner-edit-dialog/brand-campaign-partner-edit-dialog.component";
import {
  BrandCampaignPartnerStatusChartDialogComponent,
  BrandCampaignPartnerStatusChartDialogData,
  BrandCampaignPartnerStatusChartDialogResult,
} from "./brand-campaign-partners/brand-campaign-partner-status-chart-dialog/brand-campaign-partner-status-chart-dialog.component";
import {
  BrandCampaignPromoAdsWhitelistDialogData,
  BrandCampaignPromoAdsWhitelistDialogResult,
  BrandCampaignPromoAdsWhitelistDialogComponent,
} from "./brand-campaign-promo-ads/brand-campaign-promo-ads-whitelist-dialog/brand-campaign-promo-ads-whitelist-dialog.component";
import {
  CampaignPartnersSheetMatchingErrorsDialogData,
  CampaignPartnersSheetMatchingErrorsDialogResult,
  CampaignPartnersSheetMatchingErrorsDialogComponent,
} from "./brand-campaign-invite-partners/campaign-partners-sheet-matching-errors-dialog/campaign-partners-sheet-matching-errors-dialog.component";
import {
  BrandCampaignSubmitCheckDialogComponent,
  BrandCampaignSubmitCheckDialogData,
  BrandCampaignSubmitCheckDialogResult,
} from "./brand-campaign-submit-check-dialog/brand-campaign-submit-check-dialog.component";
import {
  LinkedinImagePostCreationDialogComponent,
  LinkedinImagePostCreationDialogData,
  LinkedinImagePostCreationDialogResult,
} from "./campaign-content-creation/linkedin/linkedin-image-post-creation-dialog/linkedin-image-post-creation-dialog.component";
import {
  LinkedinMultiImagePostCreationDialogComponent,
  LinkedinMultiImagePostCreationDialogData,
  LinkedinMultiImagePostCreationDialogResult,
} from "./campaign-content-creation/linkedin/linkedin-multi-image-creation-dialog/linkedin-multi-image-post-creation-dialog.component";
import {
  LinkedinVideoPostCreationDialogComponent,
  LinkedinVideoPostCreationDialogData,
  LinkedinVideoPostCreationDialogResult,
} from "./campaign-content-creation/linkedin/linkedin-video-post-creation-dialog/linkedin-video-post-creation-dialog.component";

@Injectable()
export class BrandCampaignDialogService {
  constructor(private dialog: CommonDialogService) {}

  public readonly showAd = this.dialog.createOpenDialogFn<
    BrandCampaignAdDialogData,
    BrandCampaignAdDialogResult
  >(BrandCampaignAdDialogComponent, {
    panelClass: ["sp-brand-campaign-ad"],
  });

  public readonly showBrandCampaignAddContent = this.dialog.createOpenDialogFn<
    CampaignAddContentDialogData,
    CampaignAddContentDialogResult
  >(CampaignAddContentDialogComponent, {
    panelClass: "sp-content-creation",
  });

  public readonly showBrandCampaignCategoryMove =
    this.dialog.createOpenDialogFn<
      BrandCampaignCategoryMoveDialogData,
      BrandCampaignCategoryMoveDialogResult
    >(BrandCampaignCategoryMoveDialogComponent);

  public readonly showCreation = this.dialog.createOpenDialogFn<
    BrandCampaignCreationDialogData,
    BrandCampaignCreationDialogResult
  >(BrandCampaignCreationDialogComponent);

  public readonly showInvitePartnersMatchingErrors =
    this.dialog.createOpenDialogFn<
      CampaignPartnersSheetMatchingErrorsDialogData,
      CampaignPartnersSheetMatchingErrorsDialogResult
    >(CampaignPartnersSheetMatchingErrorsDialogComponent);

  public readonly showMove = this.dialog.createOpenDialogFn<
    BrandCampaignMoveDialogData,
    BrandCampaignMoveDialogResult
  >(BrandCampaignMoveDialogComponent);

  public readonly showNameEdit = this.dialog.createOpenDialogFn<
    BrandCampaignNameEditDialogData,
    BrandCampaignNameEditDialogResult
  >(BrandCampaignNameEditDialogComponent);

  public readonly showCampaignSubmitCheck = this.dialog.createOpenDialogFn<
    BrandCampaignSubmitCheckDialogData,
    BrandCampaignSubmitCheckDialogResult
  >(BrandCampaignSubmitCheckDialogComponent, {
    panelClass: ["sp-brand-campaign-submit-check"],
  });

  public readonly showPartnerEdit = this.dialog.createOpenDialogFn<
    BrandCampaignPartnerEditDialogData,
    BrandCampaignPartnerEditDialogResult
  >(BrandCampaignPartnerEditDialogComponent);

  public readonly showContentCategoryForm = this.dialog.createOpenDialogFn<
    CampaignCategoryFormDialogData,
    CampaignCategoryFormDialogResult
  >(CampaignCategoryFormDialogComponent);

  public readonly showVideoPostForm = this.dialog.createOpenDialogFn<
    CampaignContentFormPostVideoDialogData,
    CampaignContentFormPostVideoDialogResult
  >(CampaignContentFormPostVideoDialogComponent, {
    disableClose: true,
  });

  public readonly showGoogleAdsPostForm = this.dialog.createOpenDialogFn<
    CampaignContentFormGoogleAdDialogData,
    CampaignContentFormGoogleAdDialogResult
  >(CampaignContentFormGoogleAdDialogComponent, {
    disableClose: true,
  });

  public readonly showCarouselPostForm = this.dialog.createOpenDialogFn<
    CampaignContentFormPostCarouselDialogData,
    CampaignContentFormPostCarouselDialogResult
  >(CampaignContentFormPostCarouselDialogComponent, {
    disableClose: true,
  });

  public readonly showImagePostForm = this.dialog.createOpenDialogFn<
    CampaignContentFormPostImageDialogData,
    CampaignContentFormPostImageDialogResult
  >(CampaignContentFormPostImageDialogComponent, {
    disableClose: true,
  });

  public readonly showVideoForm = this.dialog.createOpenDialogFn<
    CampaignContentFormVideoDialogData,
    CampaignContentFormVideoDialogResult
  >(CampaignContentFormVideoDialogComponent, {
    disableClose: true,
  });

  public readonly showLinkedInImagePostForm = this.dialog.createOpenDialogFn<
    LinkedinImagePostCreationDialogData,
    LinkedinImagePostCreationDialogResult
  >(LinkedinImagePostCreationDialogComponent, {
    disableClose: true,
  });

  public readonly showLinkedInMultiImagePostForm =
    this.dialog.createOpenDialogFn<
      LinkedinMultiImagePostCreationDialogData,
      LinkedinMultiImagePostCreationDialogResult
    >(LinkedinMultiImagePostCreationDialogComponent, {
      disableClose: true,
    });

  public readonly showLinkedInVideoPostForm = this.dialog.createOpenDialogFn<
    LinkedinVideoPostCreationDialogData,
    LinkedinVideoPostCreationDialogResult
  >(LinkedinVideoPostCreationDialogComponent, {
    disableClose: true,
  });

  public readonly showLinkPostForm = this.dialog.createOpenDialogFn<
    CampaignContentFormLinkPostDialogData,
    CampaignContentFormLinkPostDialogResult
  >(CampaignContentFormLinkPostDialogComponent, {
    disableClose: true,
  });

  public readonly showBannerForm = this.dialog.createOpenDialogFn<
    CampaignContentFormBannerDialogData,
    CampaignContentFormBannerDialogResult
  >(CampaignContentFormBannerDialogComponent, {
    disableClose: true,
  });

  public readonly showPartnerStatusChart = this.dialog.createOpenDialogFn<
    BrandCampaignPartnerStatusChartDialogData,
    BrandCampaignPartnerStatusChartDialogResult
  >(BrandCampaignPartnerStatusChartDialogComponent, {
    panelClass: ["sp-brand-campaign-partner-status-chart"],
  });

  public readonly showBoxPreview = this.dialog.createOpenDialogFn<
    BrandCampaignBoxPreviewDialogData,
    BrandCampaignBoxPreviewDialogResult
  >(BrandCampaignBoxPreviewDialogComponent, {
    panelClass: ["sp-brand-campaign-box-preview"],
  });

  public readonly showContentPostComments = this.dialog.createOpenDialogFn<
    CampaignContentPostCommentsDialogData,
    CampaignContentPostCommentsDialogResult
  >(CampaignContentPostCommentsDialogComponent);

  public readonly showDetailsPreview = this.dialog.createOpenDialogFn<
    BrandCampaignDetailsPreviewDialogData,
    BrandCampaignDetailsPreviewDialogResult
  >(BrandCampaignDetailsPreviewDialogComponent, {
    panelClass: ["sp-brand-campaign-details-preview"],
  });

  public readonly showPromoAdsWhitelist = this.dialog.createOpenDialogFn<
    BrandCampaignPromoAdsWhitelistDialogData,
    BrandCampaignPromoAdsWhitelistDialogResult
  >(BrandCampaignPromoAdsWhitelistDialogComponent, {
    panelClass: ["sp-brand-campaign-promo-ads-whitelist"],
  });

  public readonly showImportPartnersConfirm = this.dialog.createOpenDialogFn<
    CampaignPartnersInviteConfirmDialogData,
    CampaignPartnersInviteConfirmDialogResult
  >(CampaignPartnersInviteConfirmDialogComponent);
}
